import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaUser, FaEnvelope, FaPhone, FaComment } from "react-icons/fa";
import { db } from "../../firebase"; // Import Firebase config
import { collection, addDoc } from "firebase/firestore";
import "./Form.scss"; // Ensure this is the correct path for your SCSS file
import Image from "../../components/img/Form.png"; // Update path to image if needed

const FormPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleScroll = () => {
    const rect = document
      .getElementById("form-container")
      .getBoundingClientRect();
    if (rect.top <= window.innerHeight && rect.bottom >= 0) {
      setIsVisible(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleFocus = (e) => {
    e.target.parentNode.classList.add("focus");
  };

  const handleBlur = (e) => {
    if (e.target.value === "") {
      e.target.parentNode.classList.remove("focus");
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "enquiries"), formData);
      alert("Form submitted successfully!");
      setFormData({ name: "", email: "", phone: "", message: "" }); // Reset form
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form!");
    }
  };

  return (
    <div className="form-page">
      <div className="form-container" id="form-container">
        <motion.div
          className="form-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: isVisible ? 1 : 0 }}
          transition={{ duration: 1 }}
        >
          <h2>Enquiry Form</h2>
          <form className="enquiry-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <FaUser className="icon" />
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
                className="input"
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
              <label>Name</label>
              <span>Name</span>
            </div>
            <div className="form-group">
              <FaEnvelope className="icon" />
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
                className="input"
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
              <label>Email</label>
              <span>Email</span>
            </div>
            <div className="form-group">
              <FaPhone className="icon" />
              <input
                type="tel"
                name="phone"
                placeholder="Enter your phone number"
                value={formData.phone}
                onChange={handleChange}
                required
                className="input"
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
              <label>Phone</label>
              <span>Phone</span>
            </div>
            <div className="form-group">
              <FaComment className="icon" />
              <textarea
                name="message"
                placeholder="Enter your message"
                value={formData.message}
                onChange={handleChange}
                required
                className="input"
                onFocus={handleFocus}
                onBlur={handleBlur}
              ></textarea>
              <label>Message</label>
              <span>Message</span>
            </div>
            <button type="submit" className="btn-submit">
              Submit
            </button>
          </form>
        </motion.div>
        <div className="form-image">
          <img src={Image} alt="Form Illustration" />
        </div>
      </div>
    </div>
  );
};

export default FormPage;
